const normalizeText = (value: any) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const getLocationKey = (location: any) =>
  normalizeText(location?.id || location?.slug || location?.name || location);

const getLocationName = (location: any) =>
  String(location?.name || location || "").trim();

const getPriceKey = (packageItem: any) =>
  String(packageItem?.price || packageItem?.vehicle_detail?.price || "").trim();

const getVehicleIdentity = (packageItem: any) =>
  [
    packageItem?.vehicle_detail?.id,
    packageItem?.vehicle_detail?.name,
    packageItem?.vehicle_detail?.vehicle_type?.name,
  ]
    .filter(Boolean)
    .map(normalizeText)
    .join("|");

const buildGroupedPackage = (primaryPackage: any, packages: any[]) => {
  const vehicleMap = new Map();

  packages.forEach((packageItem: any) => {
    const identity = getVehicleIdentity(packageItem);
    if (identity && !vehicleMap.has(identity)) {
      vehicleMap.set(identity, packageItem);
    }
  });

  const vehicles = Array.from(vehicleMap.values());
  const pickupName = getLocationName(primaryPackage?.pickup_location);
  const dropName = getLocationName(primaryPackage?.drop_location);
  const hasReturnRoute = packages.some((packageItem: any) => {
    const packagePickup = getLocationKey(packageItem?.pickup_location);
    const packageDrop = getLocationKey(packageItem?.drop_location);
    return (
      packagePickup === getLocationKey(primaryPackage?.drop_location) &&
      packageDrop === getLocationKey(primaryPackage?.pickup_location)
    );
  });

  return {
    ...primaryPackage,
    name: hasReturnRoute ? `${pickupName} to ${dropName}` : primaryPackage?.name,
    groupedPackages: packages,
    groupedVehicles: vehicles,
    groupedVehicleNames: vehicles
      .map((packageItem: any) => packageItem?.vehicle_detail?.name)
      .filter(Boolean),
    groupedVehicleTypeNames: Array.from(
      new Set(
        vehicles
          .map((packageItem: any) => packageItem?.vehicle_detail?.vehicle_type?.name)
          .filter(Boolean)
      )
    ),
    routeLabel: hasReturnRoute ? `${pickupName} to/from ${dropName}` : `${pickupName} to ${dropName}`,
    hasReturnRoute,
  };
};

export const groupPackagesForDisplay = (packages: any[] = []) => {
  const groups = new Map();

  packages.forEach((packageItem: any) => {
    const pickupKey = getLocationKey(packageItem?.pickup_location);
    const dropKey = getLocationKey(packageItem?.drop_location);
    const priceKey = getPriceKey(packageItem);
    const routeKey = [pickupKey, dropKey].sort().join("__");
    const key = `${routeKey}__${priceKey}`;

    if (!pickupKey || !dropKey || !priceKey) {
      groups.set(`${packageItem?.id || groups.size}`, [packageItem]);
      return;
    }

    groups.set(key, [...(groups.get(key) || []), packageItem]);
  });

  return Array.from(groups.values()).map((group: any[]) =>
    buildGroupedPackage(group[0], group)
  );
};
